import React from 'react';
import { useNavigate } from 'react-router-dom';

const QuizGeneratorDisplay = ({ onShowContentSelector, onShowCustomQuiz }) => {
  const navigate = useNavigate();

  return (
    <div className="quiz-gen-display-container">
      <div className="quiz-gen-display-content">
        <h1 className="quiz-gen-display-title">Quiz Generator</h1>
        <p className="quiz-gen-display-subtitle">Choose how you'd like to practice</p>

        <div className="quiz-gen-options-grid">
          <div 
            className="quiz-gen-option-card" 
            onClick={() => navigate('/website-reasoning-test')}
          >
            <div className="quiz-gen-option-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <div className="quiz-gen-option-title">Practice Reasoning Tests</div>
            <div className="quiz-gen-option-subtitle">Cognitive ability assessment</div>
            <div className="quiz-gen-option-description">
              Challenge yourself with logical reasoning and problem-solving exercises designed to test analytical thinking.
            </div>
          </div>

          <div className="quiz-gen-option-card" onClick={onShowContentSelector}>
            <div className="quiz-gen-option-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
              </svg>
            </div>
            <div className="quiz-gen-option-title">Practice Admissions Tests</div>
            <div className="quiz-gen-option-subtitle">Standardized test preparation</div>
            <div className="quiz-gen-option-description">
              Take timed practice tests for UCAT, LNAT, TMUA, MAT and more. Real exam conditions with comprehensive feedback.
            </div>
          </div>

          <div className="quiz-gen-option-card" onClick={onShowCustomQuiz}>
            <div className="quiz-gen-option-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="12" y1="18" x2="12" y2="12"></line>
                <line x1="9" y1="15" x2="15" y2="15"></line>
              </svg>
            </div>
            <div className="quiz-gen-option-title">Create Custom Quiz</div>
            <div className="quiz-gen-option-subtitle">Professional quiz builder</div>
            <div className="quiz-gen-option-description">
              Upload your exam specification and past papers to generate tailored practice questions with detailed solutions.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizGeneratorDisplay;

